module.exports = __webpack_public_path__ + "static/media/Hover1_NewYork.65ccbb87.png";